<template>
  <div
    class="search-bar"
    v-bind:class="{ 'search-tenancy': $route.name == 'SearchServicesTenancy' }"
  >
    <b-container fluid>
      <b-row
        class="align-items-center"
        v-bind:class="{
          close: !cx_openMenu,
          'search-col-tenancy': $route.name == 'SearchServicesTenancy',
        }"
      >
        <b-col cols="6" md="6" lg="2">
          <div  class="logo">
            <img
              v-on:click="returnHome()"
              class="img-header-search"
              :src="cx_header_logo"
              v-bind:class="{ close: !cx_openMenu }"
              title="Clinicarx"
              alt="Clinicarx"
              loading="lazy"
            />
           </div>
          
        </b-col>

        <b-col cols="6" class="alterCep">
          <div v-if="!cx_openMenu" class="alter-cep-open">
            <span  v-on:click="cx_openMenu = !cx_openMenu" class="alter-cep"> Alterar CEP </span>
            <img width="14" height="20" v-on:click="cx_openMenu = !cx_openMenu" src="@/assets/icons/location-pin.svg" alt=""/>
           </div>
          <div v-if="cx_openMenu" class="alter-cep-close">
            <img  width="14" height="20" v-on:click="cx_openMenu = !cx_openMenu" src="@/assets/icons/location-pin.svg" alt=""/>

          </div>
        </b-col>

        <b-col cols="12" md="12" lg="3" offset-lg="5" class="not-closed div-cep-input" v-bind:class="{ close: !cx_openMenu }">
         
          <small v-if="cx_isEmptyCep" class="invalid-cep-info"> Campo Obrigatório: </small>          
          <small v-if="!cx_isInvalidCep && !cx_isEmptyCep" class="small-search-cep"> Buscando próximo a: </small>          
          <small class="invalid-cep-info" v-if="cx_isInvalidCep && !cx_isEmptyCep"> Insira um CEP válido: </small>
          
          <div class="cep-input">
            <input
              type="text"
              placeholder="Seu CEP"
              inputmode="numeric"
              v-bind:class="{ 'invalid-cep': cx_isInvalidCep || cx_isEmptyCep,}"
              v-mask="'##.###-###'"
              v-on:keyup="searchCondition()"
              v-model="cx_zipCode"
            />            
          </div>
          
        </b-col>

        <b-col cols="12" md="12" lg="2" class="not-closed btAndInfo" v-bind:class="{ close: !cx_openMenu }">
          <button
            class="btn btn-search btnAtive"
            @click="() => searchCondition(true)"
          >
            Buscar
          </button>

          <div class="cep-info bg-inf">
            <a  id="tooltip-target-1"
                  href="https://buscacepinter.correios.com.br/app/endereco/index.php"
                  target="_blank"
                  rel="noopener noreferrer">             
                  <img  src="@/assets/images/Vector.svg" alt="" style="max-width: 6vw;"/>
            </a>     
             
              <b-tooltip  directive="bottom" direction="bottom"  variant="blue" target="tooltip-target-1" triggers="hover" style="">                
                <span class="span-cep">Não sei meu CEP </span>
              </b-tooltip>
              <a style=""
                  href="https://buscacepinter.correios.com.br/app/endereco/index.php"
                  target="_blank"
                  rel="noopener noreferrer">             
                <span>Não sei meu CEP </span></a>  

          </div>
        </b-col>       
      </b-row>
    </b-container>
  </div>
</template>

<script>
import SearchBar from "@/components/ClinicsResult/SearchBar/SearchBar";

export default SearchBar;
</script>

<style lang="scss">
@import "SearchBar.scss";
</style>
